import Image from "next/image";
import { m } from "framer-motion";
import Container from "~/componentsDS/Layout/Container";
import Heading from "~/componentsDS/Typography/Heading";
import Lead from "~/componentsDS/Typography/Lead";
import MissionCircle from "./MissionCircle";
import { heroMedia } from "./data";
import { fadeUp, slideUp } from "./config/animationConfig";

const OurMission = () => {
    return (
        <section className="relative -mt-4 md:-mt-6 bg-[linear-gradient(258deg,_#E9EDF7_-7.52%,_#FFF_117.9%)] overflow-hidden z-[1]">
            <m.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                transition={{ staggerChildren: 0.3 }}
                className="relative flex flex-col items-center lg:items-start lg:justify-center pt-16 lg:py-[96px] lg:min-h-[630px] xl:min-h-[720px] text-primary500"
            >
                <Container className="relative z-[3]">
                    <m.div
                        variants={fadeUp}
                        transition={{ duration: 0.9, ease: "easeOut" }}
                        className="text-center lg:text-left lg:max-w-[440px] xl:max-w-[562px]"
                    >
                        <Heading
                            as="h2"
                            size="sm"
                            sizes={{ xl: "lg" }}
                            className="mb-8 xl:mb-16"
                        >
                            Our Mission
                        </Heading>

                        <Lead font="featureDisplay" size="sm" className="mb-4 xl:mb-6 xl:text-[36px]">
                            We deliver science-backed care designed to restore balance across your whole body — hormones, mood, metabolism, skin, and more.
                        </Lead>

                        <Lead font="featureDisplay" size="sm" className="xl:text-[36px]">
                            Because women&apos;s health was never meant to be one-size-fits-all.
                        </Lead>
                    </m.div>
                </Container>

                <m.div
                    variants={slideUp}
                    transition={{ duration: 0.9, ease: "easeOut" }}
                    className="relative lg:absolute lg:bottom-0 lg:right-0 w-[505px] lg:w-[680px] 2xl:w-[800px] aspect-[800/720] z-[2]"
                >
                    <Image
                        src={heroMedia.missionPhone}
                        alt="Inner Balance app on iPhone"
                        fill
                        sizes="70vw"
                        quality={95}
                        className="object-cover object-center"
                    />
                </m.div>

                <MissionCircle />
            </m.div>
        </section>
    );
};

export default OurMission;
